import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { yieldToEventLoop } from '../../../runtime/yield-to-event-loop.js';
import { normalizeSymbolIndexRelPath } from '../lifecycle/normalize-symbol-index-path.js';
import {
  persistSymbolIndexFileAsync,
  removeSymbolIndexFileAsync,
} from '../persistence/persist-single-file.js';
import { withSymbolIndexSqliteLock } from '../sqlite/symbol-index-sqlite-lock.js';
import { extractFileSymbolData } from './extract-file-symbol-data.js';

export async function updateSymbolIndexForFileImpl(
  parentPath: string,
  changedPath: string,
): Promise<void> {
  const relPath = normalizeSymbolIndexRelPath(parentPath, changedPath);
  if (relPath == null) return;

  const resolved = normalizeResolvedPath(parentPath);
  const { source, tags, imports } = await extractFileSymbolData(resolved, relPath);
  await yieldToEventLoop();

  await withSymbolIndexSqliteLock(async () => {
    await persistSymbolIndexFileAsync(resolved, relPath, source, tags, imports);
  });
}

export async function removeSymbolIndexForFileImpl(parentPath: string, changedPath: string): Promise<void> {
  const relPath = normalizeSymbolIndexRelPath(parentPath, changedPath);
  if (relPath == null) return;
  const resolved = normalizeResolvedPath(parentPath);
  await withSymbolIndexSqliteLock(async () => {
    await removeSymbolIndexFileAsync(resolved, relPath);
  });
}

/** Worker host entry when the caller already has a normalized relative path. */
export async function updateSymbolIndexRelPathImpl(parentPath: string, relPath: string): Promise<void> {
  const normalizedRel = relPath.replace(/\\/g, '/').replace(/^\/+/, '');
  if (!normalizedRel) return;
  const resolved = normalizeResolvedPath(parentPath);
  const { source, tags, imports } = await extractFileSymbolData(resolved, normalizedRel);
  await yieldToEventLoop();
  await withSymbolIndexSqliteLock(async () => {
    await persistSymbolIndexFileAsync(resolved, normalizedRel, source, tags, imports);
  });
}

/** Worker host entry when the caller already has a normalized relative path. */
export async function removeSymbolIndexRelPathImpl(parentPath: string, relPath: string): Promise<void> {
  const normalizedRel = relPath.replace(/\\/g, '/').replace(/^\/+/, '');
  if (!normalizedRel) return;
  const resolved = normalizeResolvedPath(parentPath);
  await withSymbolIndexSqliteLock(async () => {
    await removeSymbolIndexFileAsync(resolved, normalizedRel);
  });
}
